import React from 'react';
import PropTypes from 'prop-types';



const UserAvatarFromName = ({ name, size }) => {
    // const colorMap = {
    //     A: 'bg-red',
    //     B: 'bg-blue',
    //     C: 'bg-green',
        
    // };
    const colorMap = {
        A: 'bg-danger',   // red
        B: 'bg-primary',  // blue
        C: 'bg-success',  // green
        D: 'bg-warning',  // yellow
        E: 'bg-info',     // light blue
        F: 'bg-secondary', // gray
        G: 'bg-warning',    // light gray
        H: 'bg-dark',     // black
        I: 'bg-danger',   // red
        J: 'bg-primary',  // blue
        K: 'bg-success',  // green
        L: 'bg-warning',  // yellow
        M: 'bg-info',     // light blue
        N: 'bg-secondary', // gray
        O: 'bg-warning',    // light gray
        P: 'bg-dark',     // black
        Q: 'bg-danger',   // red
        R: 'bg-primary',  // blue
        S: 'bg-success',  // green
        T: 'bg-warning',  // yellow
        U: 'bg-info',     // light blue
        V: 'bg-secondary', // gray
        W: 'bg-warning',    // light gray
        X: 'bg-dark',     // black
        Y: 'bg-danger',   // red
        Z: 'bg-primary'   // blue
    };

    const firstLetter = name?.charAt(0).toUpperCase();
    const colorClass = colorMap[firstLetter] || 'bg-primary'; // default color

    return (
        <span className={`avatar-title rounded-circle ${colorClass}  text-white p-2`}>
            {name?.substring(0, 2).toUpperCase()}
        </span>
    );
};

UserAvatarFromName.propTypes = {
    name: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
};
export default UserAvatarFromName;
